export class GeneralLogonViewModel {
    constructor(options) {
        this.form$ = options.form$;
        this.requireTermsOfUseAgreement = !!options.requireTermsOfUseAgreement;
        this.login = ko.observable<string>(options.login).extend({ required: true });
        this.password = ko.observable<string>(null).extend({ required: true });
        this.termsOfUseAgreement = ko.observable<boolean>(options.termsOfUseAgreement);

        this.canSubmit = ko.pureComputed({
            read: () => this.termsOfUseAgreement() || !this.requireTermsOfUseAgreement,
            deferEvaluation: true
        });
    }

    readonly form$: JQuery;
    readonly requireTermsOfUseAgreement: boolean;
    readonly canSubmit: KnockoutComputed<boolean>;
    
    login: KnockoutObservable<string>;
    password: KnockoutObservable<string>;
    termsOfUseAgreement: KnockoutObservable<boolean>;

    init() {
        ko.applyBindings(this);
    }

    onSubmit() {
        this.login.isModified(true);
        this.password.isModified(true);

        if (this.isModelValid()) {
            this.form$.submit();
        }
    }

    isModelValid() {
        return this.login.isValid() && this.password.isValid();
    }
}
